/**
 * @file Confirmation dialog-related text
 */
import { __ } from '@@/bits/intl'
import alertSignSvg from 'images/alert_sign.svg'
import thinkingFaceSvg from 'images/thinking-face.svg'
import { OzConfirmationDialogBoxButtonScheme } from 'library/v4/components/OzConfirmationDialogBox.vue'
import { ConfirmationDialogPayload } from 'vuexstore/modules/confirmation_dialog'

export const ALERT_ICON: Partial<ConfirmationDialogPayload> = {
  iconSrc: alertSignSvg,
  iconAlt: __('Alert Sign'),
}

export const CONFIRM_DISCARD_CHANGES: Partial<ConfirmationDialogPayload> = {
  title: __('You have unsaved changes'),
  body: __('Are you sure you want to discard them and close this panel?'),
  confirmButtonText: __('Discard and close'),
  cancelButtonText: __('Keep working'),
}

export const CONFIRM_DELETE_POST: Partial<ConfirmationDialogPayload> = {
  ...ALERT_ICON,
  isCodeProtected: false,
  title: __('Delete post?'),
  body: __('Are you sure you want to delete this post? This cannot be undone!'),
  confirmButtonText: __('Delete'),
  cancelButtonText: __('Nevermind'),
}

export const CONFIRM_DISCARD_SETTING_CHANGES: Partial<ConfirmationDialogPayload> & { discardButtonText: string } = {
  ...CONFIRM_DISCARD_CHANGES,
  confirmButtonText: __('Save and exit'),
  discardButtonText: __('Exit without saving'),
}

export const deleteWallConfirmationParams = (wallTitle?: string): Partial<ConfirmationDialogPayload> => ({
  isCodeProtected: true,
  title: wallTitle ? __('Delete "%{wallTitle}"?', { wallTitle }) : __('Delete this padlet?'),
  body: __('This action cannot be undone.'),
  confirmButtonText: __('Delete'),
  cancelButtonText: __('Nevermind'),
  buttonScheme: OzConfirmationDialogBoxButtonScheme.Danger,
  shouldFadeIn: false,
})

export const THINKING_FACE_ICON: Partial<ConfirmationDialogPayload> = {
  iconSrc: thinkingFaceSvg,
  iconAlt: __('Thinking Face'),
}

export default {
  ALERT_ICON,
  CONFIRM_DISCARD_CHANGES,
  CONFIRM_DELETE_POST,
  deleteWallConfirmationParams,
  THINKING_FACE_ICON,
}
